import axios from 'axios';

import { AuthenticationClient } from '../authentication/client';
import { logger } from '../logging';

import { UpdateFilterPermissionsRequest } from './types';
import { FILTERS_URL } from './utils';

export const updateFilter = async (filter: UpdateFilterPermissionsRequest, basePath = FILTERS_URL) => {
  try {
    const token = await AuthenticationClient.getInstance().getAccessToken();

    const permissions = filter.permissions;

    const body = {
      permissions,
      sharingContext: filter?.sharingContext,
    };

    await axios.patch(`/v2/filters/${filter.id}`, body, {
      baseURL: basePath,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (e) {
    logger.error(e);
    throw e;
  }
};
